import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Card, ListGroup } from "react-bootstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";
import apiClient from "../Login/apiClient";
import { ToastContainer, toast } from "react-toastify";

function SupportedGoals() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [supportedGoals, setSupportedGoals] = useState([]);
  const navigate = useNavigate();

  const StyledCard = styled(Card)`
    text-align: center;
    margin-bottom: 10px; // カードの下に余白を追加
  `;

  const StyledCardHeader = styled(Card.Header)`
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 10px; // カードの下に余白を追加
  `;

  const StyledListGroup = styled(ListGroup)`
    width: 100%;
    margin-right: 400px;
    .list-group-item {
      padding: 10px 20px; // パディングを調整してコンテンツの配置を整える
    }
  `;

  const StyledListGroupItem_Dream = styled(ListGroup.Item)`
    display: flex;
    align-items: center;
    margin-left: 30%;
    margin-right: 30%;
    color: #333;
  `;

  const StyledLink = styled(Link)`
    // &:hover {
    //   color: white;
    //   text-decoration: none;
    // }
  `;

  const ActionDeleteButton = styled(Button)`
    width: auto;
    padding: 5px 10px;
    margin-left: 10px;
    border: 1px solid black;
  `;

  const handleDelete = (goal) => {
    navigate("/DeleteGoalRegister", { state: { goal } });
  };

  useEffect(() => {
    const fetchSupportedGoals = async () => {
      try {
        const tokens = JSON.parse(localStorage.getItem("ResponseData"));
        const token = tokens.access;
        const response = await apiClient.get(`${API_BASE_URL}/api/accounts/supported-goals/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSupportedGoals(response.data);
      } catch (error) {
        const errorCode = error?.repsonse?.status;

        if (errorCode === 500) {
          toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
        } else {
          toast.error("予期せぬエラーが発生しました。");
        }
      }
    };

    fetchSupportedGoals();
  }, []);

  return (
    <div>
      <h2></h2>
      {/* <ul>
        {supportedGoals.map((goal) => (
          <li key={goal.id} onClick={() => navigate(`/boards/${goal.goal.id}`)}>
            {goal.goal.title} - Deadline: {goal.goal.deadline}
          </li>
        ))}
      </ul> */}
      <StyledCard>
        <StyledCardHeader>応援している無謀な夢リスト</StyledCardHeader>
        <ListGroup variant="flush">
          {supportedGoals.map((goal, index) => (
            <StyledListGroupItem_Dream key={index}>
              <strong> 【タイトル】</strong>
              <StyledLink to={`/boards/${goal.id}`}> {goal.goal.title}</StyledLink>
              <br />
              <strong> 【目標実現日】</strong> {goal.goal.deadline}
              <div>
                <ActionDeleteButton variant="danger" onClick={() => handleDelete(goal)}>
                  削除
                </ActionDeleteButton>
              </div>
            </StyledListGroupItem_Dream>
          ))}{" "}
        </ListGroup>
      </StyledCard>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
}

export default SupportedGoals;
